import { createContext } from 'react';
import { QuickPriceCalculatorType } from '../../semshared/pricelist/quickprice';

export const QuickPriceCalculatorContext = createContext<QuickPriceCalculatorType | null>(null);
